import { createApi } from "@reduxjs/toolkit/query/react";

import type { AccountDTO } from "../../../../common/types/AccountDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const accountService = createApi({
  reducerPath: "accountService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Account"],
  endpoints: (builder) => ({
    getAccount: builder.query<AccountDTO, { id: string }>({
      query: ({ id }) => `api/identity/accounts/${id}`,
      providesTags: (account) => [{ type: "Account", id: account?.id }],
    }),
  }),
});

export const { useGetAccountQuery } = accountService;
